import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang'
import http from '@/utils/http'
import '@/style/index.css'
import '@/style/icon.css'

// 如何全局引入字体包，在 main.js 中引入
import '@/style/fontSize.css'

Vue.config.productionTip = false

Vue.prototype.$http = http
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { Form, Field, Checkbox, Button, RadioGroup, Radio, CheckboxGroup,Popup, Cascader, Grid, GridItem, Tab, Tabs, List, Dialog,Toast, Picker,Icon,Cell, CellGroup, NavBar,DatetimePicker,Divider, Uploader, Image as VanImage, ImagePreview  } from 'vant';

Vue.use(Form).use(Field).use(Checkbox).use(Button).use(Radio).use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Popup).use(Cascader).use(Grid).use(GridItem).use(Tab).use(Tabs).use(List).use(Dialog).use(Toast).use(Picker).use(Icon).use(Cell).use(CellGroup).use(NavBar).use(DatetimePicker).use(Divider).use(Uploader).use(VanImage).use(ImagePreview)


import 'vant/lib/index.css';



import wmtDate from '@/utils/date.js'
Vue.prototype.$wmtDate = wmtDate


// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)




Vue.use(ElementUI)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
